var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.mainLayoutLoader,_vm._b({tag:"component",on:{"selectedTalhoes":_vm.setTalhoes,"closeComponent":_vm.close}},'component',_vm.propsDown,false))}
var staticRenderFns = []

export { render, staticRenderFns }